// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__mklL2","lastUpdated":"TermsOfService_lastUpdated__2MHuB"};